import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import SelectComponent from './../Components/SelectComponent';
import {
  FormGroup,
  Col,
  ControlLabel,
} from 'react-bootstrap';

const AcquisitionMetricsSelectorComponent = ({ deviceNames, onSubmit }) => (
  <div>
    <LocalForm
      id="device-selector-form"
      onSubmit={onSubmit}
      onChange={onSubmit}
      initialState= {{ devicename: '' }}
    >
      <FormGroup>
        <Col md={4}>
          <ControlLabel>
            View Device:
          </ControlLabel>
          <Control.custom
            id="deviceName-input"
            model=".devicename"
            component={SelectComponent}
            className="form-control"
            style={{ marginRight: '10px' }}
            mapProps = {({ modelValue, onChange }) => {
              return {
                noneOption: 'Select a device...',
                options: deviceNames,
                selected: modelValue.deviceName,
                onChange: onChange
              };
            }
            }
          />
        </Col>
      </FormGroup>
    </LocalForm>
  </div>
);

AcquisitionMetricsSelectorComponent.propTypes = {
  deviceNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default AcquisitionMetricsSelectorComponent;


// WEBPACK FOOTER //
// src/Components/AcquisitionMetricsSelectorComponent.jsx